define('cartware/components/FeatureFlagged',[
	"./Utilities"
], function(
	Utils
) {

	function FeatureFlaggedComponent(component, flags) {
		if (!(this instanceof FeatureFlaggedComponent)) {
			return new FeatureFlaggedComponent(component, flags);
		}

		this.component = component;
		this.flags = flags;
	}

	FeatureFlaggedComponent.prototype = {
		flags: null,

		getFlags: function() {
			return this.flags;
		},

		getComponent: function() {
			return this.component;
		}
	}

	return FeatureFlaggedComponent;
});
